import { faCalendarDay } from '@fortawesome/pro-solid-svg-icons';
import NavItem from 'Components/NavBar/NavItem';
import { endOfDay } from 'date-fns';
import { useEffect, useState } from 'preact/hooks';
import { buildURL } from 'Shared/fetch';
import useFetch from 'use-http';

import { minuteMs } from '../../../helpers';

const REFRESH_INTERVAL_MS = 15 * minuteMs;

/**
 * Generates a function comment for the given function body.
 *
 * @param {Object} props - The props object containing the function's parameters.
 * @param {boolean} [props.showCount] - Whether to show the count. Default is true.
 * @param {boolean} [props.avoidInnerPadding] - Removes the padding on the inner element.
 * @param {function} [props.onClick] - The function to be called when the item is clicked.
 * @param {string} [props.target] - The target for the talk navigation item.
 * @return {import('preact/compat').ReactElement} The JSX element representing the TalkNavItem component.
 */
const TalkNavItem = ({ showCount = true, onClick, target, avoidInnerPadding }) => {
  const [count, setCount] = useState();

  const { get } = useFetch(buildURL('/schedules/events'), { credentials: 'include', cachePolicy: 'no-cache' });

  useEffect(() => {
    const getSchedules = async () => {
      const params = new URLSearchParams();

      const now = new Date();
      params.append('startTime', now.getTime().toString());
      params.append('endTime', endOfDay(now).getTime().toString());

      const schedulesData = await get(params);
      const { length } = schedulesData;
      if (length < 100) {
        setCount(length);
      } else if (length > 99) {
        setCount('99+');
      }
    };
    if (showCount) {
      getSchedules();
      const interval = setInterval(getSchedules, REFRESH_INTERVAL_MS);
      return () => {
        clearInterval(interval);
      };
    }
    return null;
  }, [get, showCount]);

  return (
    <NavItem
      avoidInnerPadding={avoidInnerPadding}
      text="Events"
      url="/schedule"
      icon={faCalendarDay}
      count={count}
      onClick={onClick}
      target={target}
    />
  );
};

export default TalkNavItem;
